/* eslint-disable @typescript-eslint/naming-convention */
export enum FoundationType {
	"リキッド　タイプ",
	"クッション　タイプ",
	"クリーム　タイプ",
	"エマルジョン　タイプ",
	"その他",
}
